import Vue from 'vue'
import App from './App.vue'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueLazyload from 'vue-lazyload'

Vue.use(VueToast);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'images/error.png',
  loading: 'images/loading.gif',
  attempt: 1,
  // listenEvents: [ 'scroll' ],
  lazyComponent: true
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
